"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = exports.renameKeys = void 0;

var _ramda = require("ramda");

var renameKeys = (0, _ramda.curry)(function (keysMap, obj) {
  return (0, _ramda.reduce)(function (acc, key) {
    return (0, _ramda.assoc)(keysMap[key] || key, obj[key], acc);
  }, {}, (0, _ramda.keys)(obj));
});
exports.renameKeys = renameKeys;
var capitalize = (0, _ramda.compose)((0, _ramda.join)(''), (0, _ramda.juxt)([(0, _ramda.compose)(_ramda.toUpper, _ramda.head), _ramda.tail]));
exports.capitalize = capitalize;